// extracted by mini-css-extract-plugin
export default {"catalogPage":"yN6mOR","catalogHeader":"rjCLHr","eyebrow":"wJKfDE","subtitle":"c2qYYB","backButton":"HlcCty"};